export var NATIVE_HANDLER_FRIENDLY_NAME="NATIVE";